import React from "react";
import { motion } from "framer-motion";
import JVAddressBox from "./JVAddressBox";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

const stats = [
  { value: "Attractive", label: "Profit Split" },
  { value: "$0", label: "Upfront Cost To You" },
  { value: "30-60", label: "Days To Close" },
];

const JVHero = () => {
  return (
    <section className="relative overflow-hidden bg-[#101826] py-14 sm:py-20 lg:py-24">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
          backgroundSize: "24px 24px",
        }}
      />
      <div className="relative mx-auto max-w-5xl px-4 text-center sm:px-6 lg:px-8">
        <motion.p
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeUp}
          className="mb-5 inline-block rounded-full border border-[#C1694F]/40 bg-[#C1694F]/10 px-4 py-1 text-xs font-semibold uppercase tracking-wide text-[#E8A691] sm:text-sm"
        >
          A Different Way To Sell Land
        </motion.p>

        <motion.h1
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeUp}
          className="text-3xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl"
        >
          Joint Venture with <span className="text-[#C1694F]">Landivo</span>
        </motion.h1>

        <motion.p
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeUp}
          className="mx-auto mt-4 max-w-2xl text-base text-slate-300 sm:mt-6 sm:text-xl"
        >
          Enter Your Property Address To Sell It Fast — partner with us instead
          of paying agent fees or waiting months for a buyer.
        </motion.p>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeUp}
          className="mt-8 flex justify-center sm:mt-10"
        >
          <JVAddressBox ctaLabel="Get My Offer" idPrefix="jv-hero" />
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={fadeUp}
          className="mx-auto mt-10 grid max-w-lg grid-cols-3 gap-4 sm:mt-14 sm:gap-8"
        >
          {stats.map((stat) => (
            <div key={stat.label}>
              <p className="text-xl font-bold text-white sm:text-3xl">{stat.value}</p>
              <p className="mt-1 text-[11px] leading-tight text-slate-400 sm:text-sm">
                {stat.label}
              </p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default JVHero;
